// components/LegalPage.js
import React from "react";
import NAV from "./nav";
import Carousel from "./carousel";
import PriceScroller from "../components/pricescroll";

const styles = {
  container: {
    padding: "2.5rem 1.5rem",
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
  },
  heading1: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    textAlign: "center",
    color: "#1e40af", // blue-700
  },
  section: {
    marginBottom: "3rem",
  },
  heading2: {
    fontSize: "1.5rem",
    fontWeight: "600",
    marginBottom: "1rem",
    color: "#111827", // gray-900
  },
  paragraph: {
    marginBottom: "0.75rem",
    fontSize: "1rem",
    lineHeight: "1.6",
  },
  smallText: {
    fontSize: "0.875rem",
    color: "#6b7280", // gray-600
  },
  question: {
    fontSize: "1.2rem",
    fontWeight: "20",
    marginBottom: "0.25rem",
    color: "#1f2937", // gray-800
  },
  answer: {
    marginBottom: "1.25rem",
    fontSize: "1rem",
  },
  link: {
    color: "#2563eb", // blue-600
    textDecoration: "underline",
  },
};

const LegalPage = () => {
  return (
    <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
                <NAV activetag="home"/>
                {/*<Carousel activetag="home"/>*/}
                {/*<!-- Header Start -->*/}
                <div class="container-fluid bg-breadcrumb">
                    {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                    <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>
                        <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Orion Analytics </h4>
                        {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                        {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                        {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                        {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                        {/*</ol>*/}
                    </div>
                </div>
            </div>
                {/*<!-- Header End -->*/}
            {/*<!-- Navbar & Hero End -->*/}
        <div style={styles.container}>
      <h1 style={styles.heading1}>Legal & Support</h1>

      {/* === Terms & Conditions === */}
      <section id="terms" style={styles.section}>
        <h2 style={styles.heading2}>Terms & Conditions</h2>
        <p style={styles.paragraph}>
          By accessing or using Orion Analytics (orionics.in), you agree to be bound by these Terms and Conditions.
          These govern your use of the website and any services or content provided herein.
        </p>
        <p style={styles.paragraph}>
          Orion Analytics (orionics.in) may modify, suspend, or discontinue its offerings at any time without prior
          notice. The data is provided for personal, non-commercial use only and may not be redistributed.
        </p>
        <p style={styles.smallText}>
          This website complies with India’s Information Technology Act, 2000 and its associated rules.
        </p>
      </section>

      {/* === Disclaimer === */}
      <section id="disclaimer" style={styles.section}>
        <h2 style={styles.heading2}>Disclaimer</h2>
        <p style={styles.paragraph}>
          Orion Analytics (orionics.in) provides analytics and data purely for informational purposes. We do not guarantee
          accuracy, completeness, or timeliness of the data.
        </p>
        <p style={styles.paragraph}>
          No content on this site constitutes financial, investment, legal, or tax advice. Users should
          consult a SEBI-registered advisor before making investment decisions.
        </p>
        <p style={styles.smallText}>
          Use of the site is at your own risk. Orion Analytics (orionics.in) is not liable for any losses arising directly or
          indirectly from use of our data or tools.
        </p>
      </section>

      {/* === FAQ === */}
      <section id="faq" style={styles.section}>
        <h2 style={styles.heading2}>Frequently Asked Questions (FAQ)</h2>

        {[
          {
            q: "1. Is Orion Analytics (orionics.in) SEBI registered?",
            a: "No, we are a data analytics platform and do not offer investment advice or portfolio management services.",
          },
          {
            q: "2. Is the data on this site live?",
            a: "Yes. We source real-time data from exchanges and APIs for listed instruments. Only working sections display live updates.",
          },
          {
            q: "3. Can I rely on this data for trading?",
            a: "This site is for educational and research purposes. Always double-check with your broker or registered data vendor before making trades.",
          },
          {
            q: "4. What instruments are covered?",
            a: "We currently cover equities, indices, and derivative data from Indian markets, primarily Nifty 200 stocks and related options.",
          },
          {
            q: "5. Can I request new features or data?",
            a: (
              <>
                Yes, we welcome suggestions. Email us at{" "}
                <a style={styles.link} href="mailto:support@orionics.in">
                  support@orionics.in
                </a>
              </>
            ),
          },
          {
            q: "6. Will you store or share my personal data?",
            a: "We follow strict privacy protocols. Any analytics data collected is anonymized, and we do not share user information with third parties.",
          },
          {
            q: "7. Is there a mobile version?",
            a: "Not yet. We are working on it. At present, our site is best viewed on a PC browser.",
          },
          {
            q: "8. Do you comply with legal requirements?",
            a: "Yes, Orion Analytics (orionics.in) complies with the Information Technology Act, 2000, and relevant Indian data protection regulations.",
          },
          {
            q: "9. Can I use Orion Analytics (orionics.in) if I am outside India?",
            a: "Yes, our platform is accessible globally. However, all services are designed in compliance with Indian laws and financial market standards.",
          },
        ].map((item, index) => (
          <div key={index}>
            <h4 style={styles.question}>{item.q}</h4>
            <p style={styles.answer}>{item.a}</p>
          </div>
        ))}
      </section>

      {/* === Help === */}
      <section id="help" style={styles.section}>
        <h2 style={styles.heading2}>Help & Support</h2>
        <p style={styles.paragraph}>
          If you need assistance or want to report a bug or error, we’re here to help.
        </p>
        <p style={styles.paragraph}>
          📧 Email us at{" "}
          <a href="mailto:support@orionics.in" style={styles.link}>
            support@orionics.in
          </a>
        </p>
        <p style={styles.paragraph}>📞 Phone support: Coming soon</p>
        <p style={styles.paragraph}>💬 Chat support: Coming soon</p>
        <p style={styles.smallText}>
          We try to respond within 24 hours. For urgent matters, please mention “URGENT” in the email subject.
        </p>
      </section>
    </div>
    </div>
  );
};

export default LegalPage;
